'use client'
import {
  commonWhere
} from "./chunk-VCKNEC77.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/tags/event.ts
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getTagsTotalEvents = (props) => __async(void 0, null, function* () {
  try {
    const query = gql`
        query getTagsTotalEvents($where: EventFilter, $order: [EventOrder]) { 
            ${props.tags.map(
      (tag) => `${tag.slug.replace(/-/g, "_")}:eventCollection(
                    order: $order
                    where: {
                        AND: [
                            { tags: {slug: "${tag.slug}"} }
                            $where
                        ]
                    }
                ){
                    total
                }`
    ).join("\n")}
        }
    `;
    const res = yield gqlClient.request(minifyGqlQuery(query), {
      order: "order_DESC",
      where: __spreadValues(__spreadValues({}, commonWhere), props.where)
    });
    const data = res || {};
    for (const slug in data) {
      const originalSlug = slug.replace(/_/g, "-");
      res[originalSlug] = data[slug];
    }
    return data;
  } catch (error) {
    throw new Exception({ error, name: "getTagsTotalEventsException" });
  }
});
var useGetTagsTotalEvents = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getTagsTotalEvents", props],
    queryFn: () => getTagsTotalEvents(props),
    placeholderData: keepPreviousData
  }, options));
};

export {
  useGetTagsTotalEvents
};
//# sourceMappingURL=chunk-IHQWHDA5.mjs.map